import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostParticipation = () => {
    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = (uuid) => {
        fetchRequest("POST", `/event/${uuid}/participation`)
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setAlert("완료되었습니다.")
                break
            case 400:
                if (fetchResult?.data?.error_code === "uuid") setAlert("대회 uuid 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 403:
                if (fetchResult?.data?.error_code === 1) setAlert("종료된 대회 입니다.")
                else if (fetchResult?.data?.error_code === 2) setAlert("아직 접수 중이지 않은 대회 입니다.")
                else if (fetchResult?.data?.error_code === 3) setAlert("프로 자격 요구 조건에 만족하지 않습니다.")
                else if (fetchResult?.data?.error_code === 4) setAlert("리엔트리 횟수를 초과하였습니다.")
                else if (fetchResult?.data?.error_code === 5) setAlert("엔트리가 마감되었습니다.")
                else if (fetchResult?.data?.error_code === 6) setAlert("참가권을 가지고 있지 않습니다.")
                else if (fetchResult?.data?.error_code === 7) setAlert("매장 이용권을 가지고 있지 않습니다.")
                else if (fetchResult?.data?.error_code === 8) setAlert("매장 이용권의 개수가 부족합니다.")
                else if (fetchResult?.data?.error_code === 9) setAlert("레지가 마감되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("대회 데이터가 존재하지 않습니다.")
                break

        }
    }, [fetchResult])

    return [request]
}

export default usePostParticipation